import React, { useState } from 'react';
import Style from './ProjectCard.module.scss';
import ImageGallery from './ImageGallery';
import TechBadge from './TechBadge';

export default function ProjectCard({ project, onViewDetails }) {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className={Style.card}>
            {/* Card Header */}
            <div className={Style.cardHeader}>
                <div className={Style.titleSection}>
                    <div className={Style.titleRow}>
                        <h3 className={Style.title}>{project.title}</h3>
                        <span className={Style.badge}>{project.badge}</span>
                    </div>
                    <p className={Style.tagline}>{project.tagline}</p>
                </div>
            </div>

            {/* Image Gallery */}
            <div className={Style.imageWrapper}>
                <ImageGallery images={project.images} title={project.title} />
            </div>

            {/* Quick Info */}
            <div className={Style.quickInfo}>
                <div className={Style.infoItem}>
                    <span className={Style.label}>Year</span>
                    <span className={Style.value}>{project.year}</span>
                </div>
                <div className={Style.infoItem}>
                    <span className={Style.label}>Duration</span>
                    <span className={Style.value}>{project.duration}</span>
                </div>
                <div className={Style.infoItem}>
                    <span className={Style.label}>Category</span>
                    <span className={Style.value}>{project.category}</span>
                </div>
            </div>

            {/* Short Description */}
            <div className={Style.description}>
                <p>{project.shortDescription}</p>
            </div>

            {/* Highlights */}
            <div className={Style.highlights}>
                {project.highlights.slice(0, 2).map((highlight, idx) => (
                    <div key={idx} className={Style.highlightItem}>
                        <span className={Style.icon}>{highlight.icon}</span>
                        <span className={Style.text}>{highlight.text}</span>
                    </div>
                ))}
            </div>

            {/* Expandable Section */}
            <div
                className={`${Style.expandableSection} ${isExpanded ? Style.expanded : ''}`}
            >
                {isExpanded && (
                    <div className={Style.expandedContent}>
                        {/* All Highlights */}
                        <div className={Style.allHighlights}>
                            <h4>Key Achievements</h4>
                            {project.highlights.map((highlight, idx) => (
                                <div key={idx} className={Style.highlightItem}>
                                    <span className={Style.icon}>{highlight.icon}</span>
                                    <span className={Style.text}>{highlight.text}</span>
                                </div>
                            ))}
                        </div>

                        {/* Tech Stack */}
                        <div className={Style.techStack}>
                            <h4>Technology Stack</h4>
                            <div className={Style.techList}>
                                {project.techStack.map((tech, idx) => (
                                    <TechBadge key={idx} name={tech.name} category={tech.category} />
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Footer Actions */}
            <div className={Style.footer}>
                <button
                    className={Style.expandBtn}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? '▲ Collapse' : '▼ Show Details'}
                </button>
                <button
                    className={Style.viewDetailsBtn}
                    onClick={() => onViewDetails(project)}
                >
                    View Full Case Study →
                </button>
            </div>
        </div>
    );
}
